import { Media } from 'pleinchamp-api-client';
import React, { ComponentPropsWithRef, FC } from 'react';
import { ClippedImage } from '@components/ClippedImage/ClippedImage.component';
import { Text } from '@components/Text/Text.component';
import { ClippedImageStyle } from '@utils/images';
import classNames from 'classnames';

import styles from './InnovationDetailBenefice.module.scss';

type Props = ComponentPropsWithRef<'main'> & {
  beneficefirstdescription: string;
  beneficeimage: Media;
  beneficeseconddescription: string;
};

export const InnovationDetailBenefice: FC<Props> = ({
  className,
  beneficefirstdescription,
  beneficeseconddescription,
  beneficeimage,
}) => {
  const rootClass = classNames(className, styles.innoBenefice);

  return (
    <div className={rootClass}>
      <ClippedImage
        alt={beneficeimage.alt}
        caption={beneficeimage.alt}
        clipStyle={ClippedImageStyle.innovationBenefice}
        plcSrc={{ src: beneficeimage.url, type: 'external' }}
      />
      <div className="wrapper-s">
        <Text
          className={`plc-py-l h2-up-s ${styles.alignCenterBenefice}`}
          i18nKey="innovations.detail.benefices"
          tag="h2"
          variant="h3"
        />
        <Text className={`${styles.alignCenterBenefice} pre-line`} tag="p" variant="p">
          {beneficefirstdescription}
        </Text>
        <Text
          className={`${styles.alignCenterBenefice} plc-py-l h2-up-s`}
          i18nKey="innovations.detail.marche"
          tag="h2"
          variant="h3"
        />
        <Text className={`${styles.alignCenterBenefice} pre-line`}  tag="p" variant="p">
          {beneficeseconddescription}
        </Text>
      </div>
    </div>
  );
};
